import api from './api.ts'
import type { AxiosResponse } from 'axios'
import type {
  CreateReportCalculationPolicyPayload,
  PreviewReportCalculationPolicyPayload,
  ReportCalculationPolicy,
  ReportCalculationPolicyListParams,
  ReportCalculationPreviewResult,
  ValidateReportCalculationPolicyPayload,
  ValidateReportCalculationPolicyResult,
} from '@/types/report_calculation_policy_schema'
import type { PaginationMetadata } from '@/types/pagination'

const BASE_URL = 'report-calculation-policies'

export interface ReportCalculationPolicyListResponse {
  data: ReportCalculationPolicy[]
  pagination?: PaginationMetadata
}

const cleanParams = (params: Record<string, unknown>) => {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  )
}

export const listReportCalculationPolicies = (
  params: ReportCalculationPolicyListParams = {}
): Promise<AxiosResponse<ReportCalculationPolicyListResponse>> => {
  return api.get(BASE_URL, {
    params: cleanParams({
      page: 1,
      limit: 20,
      ...params,
    }),
  })
}

export const getEffectiveReportCalculationPolicy = (
  params: {
    target_period_type: string
    branch_id?: string
    period_id?: number
    class_id?: number
  }
): Promise<AxiosResponse<{ data: ReportCalculationPolicy }>> => {
  return api.get(`${BASE_URL}/effective`, { params: cleanParams(params) })
}

export const createReportCalculationPolicyDraft = (
  payload: CreateReportCalculationPolicyPayload
): Promise<AxiosResponse<{ data: ReportCalculationPolicy }>> => {
  return api.post(BASE_URL, payload)
}

export const validateReportCalculationPolicy = (
  payload: ValidateReportCalculationPolicyPayload
): Promise<AxiosResponse<{ data: ValidateReportCalculationPolicyResult }>> => {
  return api.post(`${BASE_URL}/validate`, payload)
}

export const previewReportCalculationPolicy = (
  payload: PreviewReportCalculationPolicyPayload
): Promise<AxiosResponse<{ data: ReportCalculationPreviewResult | ReportCalculationPreviewResult[] }>> => {
  return api.post(`${BASE_URL}/preview`, payload)
}

export const publishReportCalculationPolicy = (
  id: number
): Promise<AxiosResponse<{ data: ReportCalculationPolicy }>> => {
  return api.post(`${BASE_URL}/${id}/publish`)
}

export const archiveReportCalculationPolicy = (
  id: number
): Promise<AxiosResponse<{ data: ReportCalculationPolicy }>> => {
  return api.post(`${BASE_URL}/${id}/archive`)
}

export const deleteReportCalculationPolicyDraft = (
  id: number
): Promise<AxiosResponse<{ data: null }>> => {
  return api.delete(`${BASE_URL}/${id}`)
}

export default {
  listReportCalculationPolicies,
  getEffectiveReportCalculationPolicy,
  createReportCalculationPolicyDraft,
  validateReportCalculationPolicy,
  previewReportCalculationPolicy,
  publishReportCalculationPolicy,
  archiveReportCalculationPolicy,
  deleteReportCalculationPolicyDraft,
}
